import React from 'react';
import { List, ListItem, Icon } from 'framework7-react';
import { setLiteral } from '../../../js/helpers';

const MenuList = ({ configMiApp, lsLiterales, f7router }) => (
  <List menuList inset className='menuPrincipal'>
    <ListItem
      link
      key={"profile"}
      title={setLiteral(lsLiterales, 102136)} //perfil
      popupOpen="#user-data"
      className='opcion'>
      <Icon f7='person_circle' className='iconMenu' slot='media'></Icon>
    </ListItem>

    <ListItem
      link
      key={"faqs"}
      title={setLiteral(lsLiterales, 102137)} //"FAQS"
      popupOpen="#faqs"
      className='opcion'>
      <Icon f7='bubble_left' className='iconMenu' slot='media'></Icon>
    </ListItem>

    <ListItem
      link
      key={"contactUs"}
      title={setLiteral(lsLiterales, 102138)} //"CONTACTO"
      popupOpen="#contact"
      className='opcion'>
      <Icon f7='phone' className='iconMenu' slot='media'></Icon>
    </ListItem>
    <ListItem
      link
      key={"exit"}
      title={setLiteral(lsLiterales, 102139)} //"Salir"
      onClick={(e) => { e.preventDefault; f7router.navigate('/') }}
      reloadAll={true}
      className='opcion'>
      <Icon f7='return' className='iconMenu' slot='media'></Icon>
    </ListItem>
  </List>
);

export default MenuList;
